export default "__VITE_ASSET__y6uR$80$__"